import { useCallback } from "react";

import { postHTML } from "@/lib/aws-amplify/storage";
import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { PlanArticleUpdate_DesignPage_Query } from "./mutation";
import { Plan_DesignPage_Query } from "../../query/use-plan-query/query";

type Props = {
	hotelID: string;
	planID: string;
};

export const usePlanArticleUpdateMutation = ({ hotelID, planID }: Props) => {
	const { mutationFunc } = useCustomMutation(PlanArticleUpdate_DesignPage_Query);

	const onUpdate = useCallback(
		async ({
			articleHTML,
			tags,
			tagsLocation,
		}: {
			articleHTML: string;
			tags: Array<string>;
			tagsLocation: Array<string>;
		}) => {
			const { s3Object } = await postHTML({
				html: articleHTML,
				lang: LangCode.Default,
				hotelID,
				resourceID: planID,
			});

			return await mutationFunc({
				variables: {
					input: {
						hotelID,
						planID,
						article: s3Object,
						articleTitle: "",
						tags,
						tagsLocation,
					},
				},
				refetchQueries: [{ query: Plan_DesignPage_Query, variables: { hotelID, planID } }],
			});
		},

		[hotelID, mutationFunc, planID],
	);

	return {
		onUpdate,
	};
};
